import Ajaxinate from "ajaxinate";

class CollectionPage extends window.HTMLElement {
  constructor() {
    super();

    // Infinite scroll for collection
    // new Ajaxinate({
    //   loadingText: "Loading...",
    // });

    // Always on top for infinite scroll
    history.scrollRestoration = "auto";
  }
}

window.customElements.define("collection-page", CollectionPage);
